import { render, staticRenderFns } from "./ScoreReportOverview.vue?vue&type=template&id=65593e28&scoped=true&"
import script from "./ScoreReportOverview.vue?vue&type=script&lang=js&"
export * from "./ScoreReportOverview.vue?vue&type=script&lang=js&"
import style0 from "./ScoreReportOverview.vue?vue&type=style&index=0&id=65593e28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65593e28",
  null
  
)

export default component.exports